<template>
  <v-dialog v-model="show" persistent max-width="290">
    <v-card>
      <v-card-title style="font-size:16px">{{ message }}</v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn color="#D04A02" flat @click="handleCancel">取消</v-btn>
        <v-btn color="#D04A02" flat @click="handleOk">确认</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: ''
    },
    callback: {
      type: Function,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleCancel() {
      this.$emit('update:show', false)
    },
    handleOk() {
      this.callback()
      this.$emit('update:show', false)
    }
  }
}
</script>
